import { __decorate, __metadata, __param } from "tslib";
import qs from 'qs';
import { inject, injectable } from 'inversify';
import { getTimezoneId } from '@/@core/utils/date';
import { Symbols } from '../symbols';
import { HttpServiceHelper } from './utils/HttpServiceHelper';
import { isAxiosError, BoException } from '../apis/service/exception';
import { normalizeResponseData } from '@/utils/lang';
import { requestConfigWrapper, PersistentCacheConfig, PersistentCacheStrategy } from '@patsnap/common-ps-http/dist/PersistentCache';
const fullLangName = {
    cn: 'zh_CN',
    en: 'en_US',
};
function checkRedirtToLogin(status, boError) {
    // 帐号没有找到!
    if (status === 400 && boError?.numeric_error_code === 500015) {
        return true;
    }
    return false;
}
function checkRedirtToError403(status, boError) {
    // 没权限
    if (status === 403 && boError?.numeric_error_code === 20101) {
        return true;
    }
    return false;
}
function checkUnKnowError(status, boError) {
    // 未知错误
    if (status === 500 || boError?.numeric_error_code === -1 || boError?.error_code === 'errors.com.patsnap.unknown_error') {
        return true;
    }
    return false;
}
const persistCacheConfInst = new PersistentCacheConfig({
    strategy: PersistentCacheStrategy.CACHE_FIRST,
    // 请求是合法（因为只有合法的才应缓存）的二次判定, 不配置时只判定是否http 2xx
    // 如果返回体是status+data模式，可以直接用
    // detectAllowCachingHook: persistCacheConf.defaults.detectAllowCachingHook_statusdata
    async detectAllowCachingHook(resp) {
        if (!resp.ok) {
            return false;
        }
        return resp.json().then(body => {
            return !!body;
        }).catch(() => false);
    },
});
let BoHttp = class BoHttp extends HttpServiceHelper {
    constructor(i18n, httpClient, errorHandlerService, navgationService, accountApiUrls) {
        super(errorHandlerService);
        this.i18n = i18n;
        this.httpClient = httpClient;
        this.errorHandlerService = errorHandlerService;
        this.navgationService = navgationService;
        this.accountApiUrls = accountApiUrls;
        this.timezoneid = getTimezoneId();
        this.configErrorHandler();
    }
    // #region 全局错误处理相关
    configErrorHandler() {
        this.errorHandlerService.addHandler(async (error) => {
            if (!BoException.is(error)) {
                return false;
            }
            // todo 500错误处理
            const response = error?.response;
            const boError = await normalizeResponseData(response?.data);
            const status = response?.status;
            if (checkRedirtToLogin(status, boError)) {
                if (error.config.url === this.accountApiUrls.getCurrentUser) {
                    const error_code = boError?.numeric_error_code;
                    this.navgationService.goToLogin('backoffice_' + error_code);
                    return true;
                }
            }
            if (checkRedirtToError403(status, boError)) {
                if (error.config.url === this.accountApiUrls.getCurrentUser) {
                    this.navgationService.goToError403();
                    return true;
                }
                boError.error_message = this.i18n.t('loginFail.error403');
            }
            if (!boError) {
                return false;
            }
            // todo有的错误由前端翻译处理
            if (checkUnKnowError(status, boError)) {
                return;
            }
            this._errorDisplayProxy(boError.error_message);
            return true;
        });
    }
    // #endregion
    request(config) {
        const { i18n, timezoneid, } = this;
        const locale = i18n.locale || 'en';
        const lang = fullLangName[locale];
        config = {
            ...config,
            params: {
                ...config?.params,
                lang,
                timezoneid,
            },
            paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: 'brackets' });
            },
        };
        const dataGetter = config.rawResponse ? (resp) => resp : (resp) => resp.data;
        if (config.isAuthorizationCache) {
            return this.httpClient(requestConfigWrapper(config, persistCacheConfInst)).then(res => dataGetter(res), error => {
                if (!isAxiosError(error)) {
                    throw error;
                }
                error = BoException.mark(error);
                throw error;
            });
        }
        return this.httpClient(config).then(res => dataGetter(res), error => {
            if (!isAxiosError(error)) {
                throw error;
            }
            error = BoException.mark(error);
            throw error;
        });
    }
};
BoHttp = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.HttpClient)),
    __param(2, inject(Symbols.ErrorHandlerService)),
    __param(3, inject(Symbols.NavgationService)),
    __param(4, inject(Symbols.AccountApiUrls)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object])
], BoHttp);
export { BoHttp };
